import { LineProps } from './types';

export const Line: React.FC<LineProps> = ({ className, children }) => <div className={'board_line' + (className ? ` ${className}` : '')}>{children}</div>;
